import { DropDownOption } from '../models/drop-down-option';

export class FormatDropDownHelper {
  public static mapToOptions<T>(
    items: T[],
    textKey: keyof T,
    valueKey: keyof T,
  ): DropDownOption[] {
    if (!items || items.length === 0) return [];

    return items.map((item) => ({
      text: String(item[textKey]),
      value: item[valueKey] as unknown as string | number,
    }));
  }
}
